export default "__VITE_ASSET__C2G$e59l__"